export { default } from './SuccessIcon';
